import type { VerificationResultResponse } from '@/api/custom';
import type { IdentityState } from '@/store/features/plaid/identitySlice';

const trimToValue = (value: string | null | undefined) => {
  const trimmed = value?.trim();
  return trimmed || undefined;
};

const parseDateOfBirth = (value: string | null | undefined) => {
  const date = trimToValue(value);
  if (!date) return undefined;

  const parsed = new Date(`${date}T00:00:00.000Z`);
  if (Number.isNaN(parsed.getTime())) return undefined;

  return parsed.toISOString().slice(0, 10) === date ? parsed : undefined;
};

export function mapVerificationResultToKycResult(
  result: VerificationResultResponse | null | undefined,
): IdentityState {
  if (!result) return {};

  const firstName = trimToValue(result.name?.value?.first_name);
  const lastName = trimToValue(result.name?.value?.last_name);
  const dateOfBirth = parseDateOfBirth(result.date_of_birth?.value);
  const phoneNumber = trimToValue(result.phone_number?.value);
  const address = result.address?.value;
  const line1 = trimToValue(address?.street);
  const city = trimToValue(address?.city);
  const state = trimToValue(address?.region);
  const postalCode = trimToValue(address?.postal_code);
  const kycResult: IdentityState = {};

  if (firstName && lastName) {
    kycResult.firstName = firstName;
    kycResult.lastName = lastName;
  }

  if (dateOfBirth) {
    kycResult.dateOfBirth = dateOfBirth;
  }

  if (phoneNumber) {
    kycResult.phoneNumber = phoneNumber;
  }

  if (line1 && city && state && postalCode) {
    kycResult.personalAddress = {
      line1,
      line2: address?.street2 || '',
      city,
      state,
      postalCode,
    };
  }

  return kycResult;
}
